export default "__VITE_ASSET__DOgMM2e5__"